import { createRouter, createWebHistory } from 'vue-router'
import { useAuthStore } from '@/modules/auth'
import { DashboardLayout } from '@/layouts'

import { adminRoutes } from '@/modules/admin'
import { authRoutes } from '@/modules/auth'
import { dashboardErrorRoutes, errorRoutes } from '@/modules/errors'
import { profileRoutes } from '@/modules/profile'
import { systemRoutes } from '@/modules/system'
import { ucAdminRoutes } from '@/modules/uc-admin'
import { ucUserRoutes } from '@/modules/uc-user'
import { phoneRoutes } from '@/modules/phone-numbers'
import { reportsRoutes } from '@/modules/reports'
import { billingRoutes } from '@/modules/billing'

const DashboardPage = () => import('@/modules/dashboard').then((m) => m.DashboardPage)
const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      redirect: '/dashboard'
    },
    ...authRoutes,
    {
      path: '/admin/resellers/preview/:id',
      name: 'resellers-preview',
      component: () => import('@/modules/admin/resellers/pages/ResellerPreviewPage.vue'),
      meta: { requiresAuth: false }
    },
    {
      path: '/dashboard',
      component: DashboardLayout,
      meta: { requiresAuth: true },
      children: [
        {
          path: '',
          name: 'dashboard',
          component: DashboardPage
        },
        ...adminRoutes,
        ...systemRoutes,
        ...ucAdminRoutes,
        ...ucUserRoutes,
        ...profileRoutes,
        ...dashboardErrorRoutes,
        ...phoneRoutes,
        ...reportsRoutes,
        ...billingRoutes
      ]
    },
    ...errorRoutes
  ]
})

router.beforeEach((to, from, next) => {
  // Dismiss any lingering modal portals and restore body scroll/interaction on route change
  if (typeof document !== 'undefined' && to.path !== from.path) {
    document
      .querySelectorAll('[data-reka-portal], [data-radix-portal]')
      .forEach((el) => el.remove())
    document.body.style.pointerEvents = ''
    document.body.style.overflow = ''
  }

  const authStore = useAuthStore()

  if (to.meta.requiresAuth && !authStore.isAuthenticated) {
    next({ name: 'login' })
  } else if (to.name === 'login' && authStore.isAuthenticated) {
    next({ name: 'dashboard' })
  } else {
    next()
  }
})

router.afterEach((to, from, failure) => {
  if (!failure) {
    try {
      sessionStorage.removeItem('chunk-reload')
    } catch {
      // Ignore storage errors in restricted privacy modes
    }
  }
  if (typeof document !== 'undefined' && to.path !== from.path) {
    document.body.style.pointerEvents = ''
    document.body.style.overflow = ''
  }
})

router.onError((error, to) => {
  if (!to?.fullPath) return

  if (
    error?.message?.includes('Failed to fetch dynamically imported module') ||
    error?.message?.includes('Importing a module script failed') ||
    error?.message?.includes('error loading dynamically imported module') ||
    error?.message?.includes('Unable to preload CSS')
  ) {
    try {
      if (sessionStorage.getItem('chunk-reload') !== to.fullPath) {
        sessionStorage.setItem('chunk-reload', to.fullPath)
        window.location.assign(to.fullPath)
      } else {
        sessionStorage.removeItem('chunk-reload')
      }
    } catch {
      window.location.assign(to.fullPath)
    }
  }
})

export default router
